<section class="biometry animate__animated animate__fadeIn"
         fxLayout="column"
         fxLayoutAlign="center center">
  <div class="pos-relative">
    <button mat-mini-fab
            class="biometry__close"
            color="primary"
            (click)="cancel()"
            [ngClass.gt-xs]="'device-gtxs'">
      <mat-icon>close</mat-icon>
    </button>
    <div fxLayout="column"
         fxLayoutAlign="center center">
      <video #video
             id="video"
             class="biometry__video"
             autoplay
             playsinline></video>
      <canvas #canvas
              [hidden]="true"></canvas>
    </div>
    <button class="biometry__face-icon"
            mat-mini-fab
            color="primary"
            fxLayoutAlign="center center"
            (click)="capture()"
            [disabled]="!captureStarted">
      <mat-icon>face</mat-icon>
    </button>

    <div class="biometry__disclaimer mt-3fa"
         fxLayoutAlign="center center">
      <span *ngIf="!validating">
        Posicione o rosto e ative a verificação.
      </span>
      <span *ngIf="validating">
        Validando sua biometria. Por favor aguarde!
      </span>
    </div>

    <div *ngIf="validating"
         class="biometry__load"
         fxLayout="column"
         fxLayoutAlign="center center">
      <mat-spinner color="pimary"></mat-spinner>
    </div>
  </div>
</section>
